module.exports = __webpack_public_path__ + "img/send-active.9046d05b.svg";